module.exports = __webpack_public_path__ + "static/media/img23.641df5a4.JPG";